import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertToFixedNegativeNumber'
})
export class ConvertToFixedNegativeNumber implements PipeTransform {
  transform(input: number | string | null | undefined, symbol: string, numChars: 2 | 4): string {
    let transformed = '';
    if (input !== undefined) {
      const value: number = parseFloat(input!.toString().replace(/,/g, ''));
      transformed =
        symbol +
        (Number(value) < 0
          ? '(' +
            Math.abs(value)
              .toFixed(numChars)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            ')'
          : Number(value)
              .toFixed(numChars)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      if (numChars === 4) {
        transformed = transformed.replace(/,/g, '');
      }
    }
    return transformed;
  }
}
